import React from "react"
import styled, { withTheme, css } from "styled-components"
import { colors } from "buoy-theme"

import { ButtonContainer } from "../../common/components/Container"

const ThumbGroup = styled.g`
  fill: ${props => (props.selected ? colors.primary(props) : "#FFF")};
  ${props =>
    !props.selected
      ? css`
          html.non-touch &:hover {
            fill: ${colors.primary(props)};
            fill-opacity: 0.1;
          }
        `
      : ""};
`

const Thumb = ({ theme, selected, down, left, onClick }) => (
  <ButtonContainer
    width="1.25rem"
    height="1.33rem"
    marginRight={!down && `24px`}
    rotation={down ? "180deg" : "0"}
    onClick={onClick}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
    >
      <ThumbGroup
        selected={selected}
        fillOpacity=".5"
        fillRule="evenodd"
        stroke={theme.colors.primary}
        strokeLinecap="round"
        strokeWidth="1.5"
        strokeLinejoin="round"
      >
        <path d="M13.6 8.35v-4.2A3.15 3.15 0 0 0 10.45 1l-4.2 9.45V22h11.844a2.1 2.1 0 0 0 2.1-1.785l1.449-9.45a2.1 2.1 0 0 0-2.1-2.415H13.6zM6.25 22H3.1A2.1 2.1 0 0 1 1 19.9v-7.35c0-1.16.94-2.1 2.1-2.1h3.15V22z" />
      </ThumbGroup>
    </svg>
  </ButtonContainer>
)

export default withTheme(Thumb)



// WEBPACK FOOTER //
// ./assets/feedback/images/Thumb.js